const cookieName = 'zendeskMetaData';

const fieldIds = {
    meta: '360006094140',
    workspaceId: '25919134016658',
    role: '26483468240146',
    plan: '26483458540690',
}

// CakeZendesk is used by external scripts, such as contact form script
window.CakeZendesk = {
    mountForm: (form) => {
        const preparedFields = prepareConversationFields();
        for (const field of preparedFields) {
            let input = form.querySelector(`input[name="${field.id}"], input[id="${field.id}"]`);
            if (!input) {
                const p = document.createElement('p');
                p.id = `zendesk_field_${field.id}`;

                input = document.createElement('input');
                input.type = 'hidden';
                input.name = field.id;
                input.id = field.id;

                p.append(input);
                form.appendChild(p);
            }
            input.value = field.value;
        }
    }
};

intervalRef = setInterval(() => {
    if (!window.zE) return;
    zE('messenger:on', 'open', () => setConversationFields());
    setConversationFields();
    clearInterval(intervalRef);
}, 500);

function setConversationFields() {
    zE('messenger:set', 'conversationFields', prepareConversationFields());
}

function prepareConversationFields() {
    const data = prepareAllMetaData();
    const fields = [];

    if (data.workspaceId) {
        fields.push({id: fieldIds.workspaceId, value: data.workspaceId});
        delete data.workspaceId;
    }

    if (data.role) {
        fields.push({id: fieldIds.role, value: data.role});
        delete data.role;
    }

    const plan = data.plan || data.subscription;
    if (plan) {
        fields.push({id: fieldIds.plan, value: plan});
        delete data.plan;
        delete data.subscription;
    }

    fields.push({id: fieldIds.meta, value: toText(data)});

    return fields;
}

function prepareAllMetaData() {
    let data = getDataFromCookie();
    data = resolveTimezone(data);
    return {
        platform: getPlatform(),
        ...data,
    };
}

function resolveTimezone(data) {
    const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const profileTimezone = data.timeZone || data.timezone || data.profileTimeZone || data.profileTimezone;
    delete data.timeZone;
    delete data.timezone;
    delete data.profileTimeZone;
    delete data.profileTimezone;

    const timezoneData = {};
    if (!profileTimezone) {
        timezoneData.timezone = systemTimezone;
    } else if (systemTimezone === profileTimezone) {
        timezoneData.timezone = systemTimezone + ' (OK)';
    } else {
        timezoneData.systemTimezone = systemTimezone;
        timezoneData.profileTimezone = profileTimezone;
    }

    return {
        ...timezoneData,
        ...data,
    }
}

function toText(data) {
    return Object.entries(data).map(field => {
        field[0] = camelCaseToHumanReadable(field[0]);
        field[0] = toTitleCase(field[0]);
        field[0] = idToUpperCase(field[0]);
        return field.join(': ');
    }).join('\n');
}

function camelCaseToHumanReadable(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
}

function toTitleCase(str) {
    return str.replace(
        /\w\S*/g,
        text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
}

function idToUpperCase(str) {
    const parts = str.split(' ');
    return parts.map(part => {
        if (part.toLowerCase() === 'id') {
            return part.toUpperCase();
        }
        return part;
    }).join(' ');
}

function getDataFromCookie() {
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
            const base64Data = cookie.substring(name.length, cookie.length);
            try {
                const dataString = decodeBase64(base64Data);
                if (!dataString) {
                    console.error('No data found in cookie:', cookie);
                    return {
                        error: 'No data found in cookie'
                    }
                }
                const data = JSON.parse(dataString);
                const isObject = typeof data === 'object' && data !== null;
                if (!isObject) {
                    console.error('Invalid data format in cookie:', data);
                    return {
                        error: 'Invalid data format in cookie: ' + data
                    }
                }
                return data;
            } catch (e) {
                console.error('Error parsing cookie data:', e);
                return {
                    error: 'Invalid JSON format in cookie data'
                };
            }
        }
    }
    return {};
}

function decodeBase64(str) {
    return decodeURIComponent(atob(str));
}

function getPlatform() {
    return navigator.whichBrowser + ", " + getOSName();
}

function getOSName() {
    let OSName = "Unknown";
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") !== -1) OSName = "Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") !== -1) OSName = "Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") !== -1) OSName = "Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") !== -1) OSName = "Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") !== -1) OSName = "Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") !== -1) OSName = "Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac") !== -1) OSName = "Mac";
    if (window.navigator.userAgent.indexOf("iPhone") !== -1 || window.navigator.userAgent.indexOf("iPad") !== -1) OSName = "iOS";
    if (window.navigator.userAgent.indexOf("X11") !== -1) OSName = "UNIX";
    if (window.navigator.userAgent.indexOf("Linux") !== -1) OSName = "Linux";
    return OSName;
}

navigator.whichBrowser = (function () {
    var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
})();
